<div *ngIf="loading"
  class=" d-flex flex-column gap-2 align-self-center text-center align-items-center justify-content-center p-2"
  style="min-height: 190px;">
  <div class="loader justify-content-center align-items-center"></div>
</div>
<div *ngIf="!loading && !error" class="position-relative d-flex flex-column gap-0 h-100">
  <div *ngIf="data.mode === 'purchase'" class="align-self-end mb-2">
    <img style="cursor: pointer; width: 1.75rem" (click)="closeDialog()"
      src="assets/icons/group-sharing/cancel-white.svg" alt="Close" />
  </div>
  <div *ngIf="data.mode === 'purchase'" class="d-flex flex-column col-12 gap-4 p-2">
    <div class="d-flex col-12 align-items-start justify-content-between p-0">
      <h2 *ngIf="data.eventType === 'SHOWCASE'" mat-dialog-title class="cus-title">
        Buy a ticket to enjoy the event! OR <br>Get an <a style="color: white;" href="cinejoy/all-access-pass">All-Access Cinejoy
          Festival Pass </a>
      </h2>
      <h2 *ngIf="data.eventType === 'SPOTLIGHT'" mat-dialog-title class="cus-title p-0
         m-0">
        Buy a ticket to enjoy the event! OR <br>Get an <a style="color: white;" href="cinejoy/how-to">All-Access Cinejoy
          Festival Pass </a>
        <!-- {{puchaseType!='singlePurchase'?'Buy tickets to enjoy the event with your friends and guests!':"Buy ticket to enjoy the event! Or <br> get an <a style='color: white;' href='cinejoy/how-to'>All-Access Cinejoy Festival Pass. </a> "}} -->
      </h2>
      <h2 *ngIf="puchaseType=='subscription'" mat-dialog-title class="cus-title">
        <strong>{{data.purchaseTransactionType=='SUBSCRIPTION_SPOTLIGHT'?"Unlock the World of Spotlight
          Events!":data.purchaseTransactionType=='SUBSCRIPTION_SHOWCASE'?"Unlock the World of Showcase Movies!":"Unlock
          All Spotlight Events and Showcase Movies"}}</strong>
      </h2>
    </div>
    <div *ngIf="data.puchaseType!='subscription'"
      class="d-flex justify-content-start align-items-center gap-2 col-12 p-0 mobile-title">
      <span class="fs-4 text-white ">Event Name:</span>
      <p class="fs-5 m-0 fw-boldish" style="font-weight: 600;">{{ cinejoyPremierDetails?.name }}</p>
    </div>
    <div *ngIf="data.puchaseType!='subscription'"
      class="d-flex justify-content-start align-items-center gap-2 col-12 p-0">
      <span class="fs-4 text-white ">{{puchaseType!='singlePurchase'?'Single Ticket Amount:':'Ticket Price :'}}</span>
      <p class="fs-5 m-0 fw-boldish">
        {{ eventPrice.ticketAmount / 100 | currency }}
      </p>
    </div>
    <div *ngIf="data.eventType === 'SPOTLIGHT' && puchaseType == 'bulkPurchase'">
      <mat-form-field class="example-chip-list" appearance="fill">
        <mat-label>Select Friends & Guests</mat-label>
        <mat-chip-list #chipList aria-label="User Selection">
          <mat-chip *ngFor="let user of selectedUsers" (removed)="remove(user)">
            {{ user.name }}
            <span matChipRemove><img src="assets/icons/group-sharing/cancel.svg" alt="" style="width: 20px" /></span>
          </mat-chip>
          <input class="cus-search-users" placeholder="Enter User Name" #userInput [formControl]="myControl"
            [value]="myControl.value" [matAutocomplete]="auto" [matChipInputFor]="chipList"
            [matChipInputSeparatorKeyCodes]="separatorKeysCodes" />
        </mat-chip-list>
        <mat-autocomplete #auto="matAutocomplete" (optionSelected)="selectedItems($event)">
          <mat-option *ngFor="let option of filteredOptions | async" [value]="option.userId">
            {{ option.value }}
          </mat-option>
        </mat-autocomplete>
      </mat-form-field>
      <span class="err-msg" *ngIf="invalidUserIds">Enter a valid User Name to add to the purchase list
      </span>
    </div>

    <div *ngIf="data.eventType === 'SPOTLIGHT' && puchaseType == 'bulkPurchase'">
      <mat-form-field appearance="fill" style="width: 100%">
        <mat-label>Empty ticket count </mat-label>
        <input matInput class="cus-ticket-count" placeholder="Enter how many empty ticket you want to purchase ? "
          #userInput [formControl]="emptyTicketCount" [value]="emptyTicketCount.value" />
      </mat-form-field>
      <span class="err-msg" *ngIf="emptyTicketCount.hasError('invalidInteger')">
        Please enter a valid integer for the ticket count.
      </span>
    </div>

    <!-- *ngIf="selectedUsers.length || emptyTicketCount.value>0" -->
    <div *ngIf="puchaseType==='bulkPurchase'"
      class="d-flex justify-content-start align-items-center gap-2 col-12 p-0 m-0">
      <span class="fs-8 text-white fw-boldish">Total Amount (Include: 1 Host tix + {{this.selectedUsersIds.length}}
        Individual tix + {{this.emptyTicketCount.value?this.emptyTicketCount.value:0}} empty tix):</span>
      <p class="fs-6 m-0">
        {{
        ((selectedUsers.length + 1) * eventPrice.ticketAmount) / 100 +
        (emptyTicketCount.value * eventPrice.ticketAmount) / 100 | currency
        }}
      </p>
    </div>

    <div *ngIf="data.purchaseTransactionType==='SUBSCRIPTION_ALL' && data.availableSubscription"
      class="d-flex justify-content-start align-items-center col-12 p-0">
      <p class="fs-6 m-0 text-start">
        <span>&#9679;</span> Your subscription will be updagared to view
        "<strong>{{(data.availableSubscription==='SPOTLIGHTSUBSCRIBED')?'Showcase': 'Spotlight'}}</strong>" Movies
      </p>
    </div>

    <div *ngIf="data.puchaseType=='subscription'"
      class="d-flex justify-content-start align-items-center gap-2 col-12 p-0">
      <span class="fs-4 text-white fw-boldish">{{data.purchaseTransactionType==='SUBSCRIPTION_ALL'?'All Access Pass
        Amount : ' : data.purchaseTransactionType==='SUBSCRIPTION_SPOTLIGHT'?'Spotlight Access Pass Amount :
        ':data.purchaseTransactionType==='SUBSCRIPTION_SHOWCASE'?'Showcase Access Pass Amount : ' :'Total ticket amount
        :'}} </span>
      <p class="fs-5 m-0">
        {{ subscriptionDetails.subscriptionPrices[0].subscriptionAmount / 100 | currency }}
      </p>
    </div>
  </div>

  <div *ngIf="data.mode === 'callback'" class="d-flex flex-column col-12 gap-4 p-4">
    <div *ngIf="!(data.mode === 'callback' && paymentResponse) &&!error"
      class=" d-flex flex-column gap-2 align-self-center text-center">
      <div class="loader"></div>
      <span style="margin-top: 10px;">Fetching Confirmation....</span>
    </div>

    <div *ngIf="(data.mode === 'callback' && paymentResponse) && !error"
      class="d-flex flex-column col-12 justify-content-center gap-4 p-0 align-items-center">
      <svg version="1.1" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 130.2 130.2">
        <circle class="path circle" fill="none" stroke="#73AF55" stroke-width="6" stroke-miterlimit="10" cx="65.1"
          cy="65.1" r="62.1" />
        <polyline class="path check" fill="none" stroke="#73AF55" stroke-width="6" stroke-linecap="round"
          stroke-miterlimit="10" points="100.2,40.2 51.5,88.8 29.8,67.5 " />
      </svg>


      <span class="fs-5 text-white fw-light text-left lh-base w-100">
        Thank you for your purchase. You may now enjoy your film/event. Please go to the
        <a (click)="openMyTicket()" class="text-danger" style="text-decoration: none; cursor: pointer;"> My Tickets</a>
        section of Cinejoy for your lineup of purchased films, events, passes.
      </span>
    </div>
    <div *ngIf="(data.mode === 'callback' && paymentResponse) && data.purchaseTransactionType!=='SUBSCRIPTION'"
      class="d-flex justify-content-start align-items-center gap-2 col-12 p-0">
      <span class="fs-6 text-white m-0">Event Name:</span>
      <p class="fs-6 m-0 fw-boldish">{{ cinejoyPremierDetails?.name }}</p>
    </div>
    <div *ngIf="data.mode === 'callback' && paymentResponse"
      class="d-flex justify-content-start align-items-center gap-2 col-12 p-0">
      <span class="fs-6 text-white fw-boldish">{{paymentResponse.purchaseTransactionType==='SUBSCRIPTION_ALL'?'All
        Access Pass Amount : ' : paymentResponse.purchaseTransactionType==='SUBSCRIPTION_SPOTLIGHT'?'Spotlight Access
        Pass Amount : ':paymentResponse.purchaseTransactionType==='SUBSCRIPTION_SHOWCASE'?'Showcase Access Pass Amount :
        ' :'Total ticket amount :'}} </span>
      <p class="fs-6 m-0 fw-boldish">
        {{ paymentResponse.amountTotal/100 | currency }}
      </p>
    </div>
    <div *ngIf="data.mode === 'callback' && paymentResponse?.emptyTicketCount"
      class="d-flex justify-content-start align-items-center gap-2 col-12 p-0">
      <span class="fs-6 text-white fw-boldish">Available empty tickets : </span>
      <p class="fs-6 m-0">{{paymentResponse.emptyTicketCount }}</p>
    </div>

    <div *ngIf="(data.mode === 'callback' && paymentResponse) && ticketGuests.length>0"
      class="d-flex col-12 justify-content-start gap-2 p-0 align-items-center">
      <span class=" fs-6 text-white fw-boldish ">Confirmed ticket for guests:</span>
      <mat-chip-list aria-label="User selection">
        <mat-chip *ngFor="let userDetails of ticketGuests"
          class="text-center fs-8"><span>{{userDetails.firstName}}</span>
          <span>{{userDetails.lastName}}</span></mat-chip>
      </mat-chip-list>
    </div>

    <!-- <div
      *ngIf="data.mode === 'callback' && paymentResponse"
      class="d-flex col-12 justify-content-center gap-4 p-0"
    >
      <span class="fs-4 text-white fw-light text-center lh-base w-75">
        Check out <span class="text-danger">My Tickets</span> section to get
        more details including the event link and the complete guests list.
      </span>
    </div> -->
  </div>
  <div class="d-flex justify-content-end align-items-center gap-2 mt-auto pb-2  m-0 mobile-btn-align">
    <button *ngIf="data.mode === 'callback' && paymentResponse" mat-flat-button
      style="width: 6rem; height: 2.5rem;margin-top: 10px;" (click)="closeConfirmationDialog()">
      Got it
    </button>
    <button *ngIf="data.mode !== 'callback'" mat-flat-button style="width: 6rem; height: 2.5rem"
      (click)="closeDialog()">
      Cancel
    </button>
    <button *ngIf="data.mode !== 'callback'" mat-flat-button color="primary"
      (click)="initiateBulkPurchase(data.eventType)" style="background: #de1b36; width: 8rem; height: 2.5rem ">
      Buy Now
    </button>
  </div>
</div>
<div *ngIf="!loading && error" class="position-relative d-flex col-12 p-0 justify-content-center h-100">
  <div class="d-flex flex-column col-12 align-items-start justify-content-between p-0">
    <div class="d-flex col-12 p-0 align-items-start justify-content-between">
      <h2 mat-dialog-title class="cus-title">Oops... Something went wrong!</h2>
      <img style="cursor: pointer; width: 1.75rem" (click)="closeDialog()"
        src="assets/icons/group-sharing/cancel-white.svg" alt="Close" />
    </div>
    <p>
      Oops... Something went wrong. Please close this popup and try again. If
      the problem persists, contact support.
    </p>
  </div>
</div>

<!--  Stripe confirmatio error handeling  -->
<div *ngIf="isConfirmationError" class="position-relative d-flex col-12 p-0 justify-content-center h-100">
  <div class="d-flex flex-column col-12 align-items-start justify-content-between p-0">
    <div class="d-flex col-12 p-0 align-items-start justify-content-between">
      <h2 mat-dialog-title class="cus-title">Oops... Something went wrong!</h2>
      <img style="cursor: pointer; width: 1.75rem" (click)="closeDialog()"
        src="assets/icons/group-sharing/cancel-white.svg" alt="Close" />
    </div>
    <p>
      Oops... Something went wrong. Please refresh the page to try again. If
      the problem persists, contact support.
    </p>
    <button *ngIf="isConfirmationError" mat-flat-button
      style="align-self:flex-end;width: 6rem; height: 2.5rem;margin-top: 10px;" (click)="reloadPage()">
      Refresh
    </button>
  </div>
</div>